export default {
  contacts: {
    phone: '(980) 260-1500',
    email: 'info@bundleloan.com',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en/settings.js